const phone = [
  '(111) 111-1111',
  '(222) 222-2222',
  '(333) 333-3333',
  '(444) 444-4444',
  '(555) 555-5555',
  '(666) 666-6666',
  '(777) 777-7777',
  '(999) 999-9999',
];

export default phone;



// WEBPACK FOOTER //
// ./src/utils/blockedPhones.js